import { Typography } from '@euler/app/components/typography';
import { Icon } from '@euler/components/Icomoon';
import { HStack } from '@euler/components/layout/Stack';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { TOKENS } from '../constants';

export const SubscriptionChip = memo(
  ({ subscribed }: { subscribed: boolean }) => {
    const { rpx } = useResponsiveContext();
    const color = subscribed ? TOKENS.subscribedText : TOKENS.unsubscribedText;
    const bg = subscribed ? TOKENS.subscribedBg : TOKENS.unsubscribedBg;
    return (
      <HStack
        css={`
          border-radius: ${rpx(4)}px;
          padding: 0 ${rpx(8)}px;
          height: ${rpx(20)}px;
          background-color: ${bg};
          align-items: center;
          margin-left: ${rpx(6)}px;
        `}
      >
        <Icon
          name="wechat"
          size={rpx(11)}
          color={color}
          css={`
            margin-right: ${rpx(3)}px;
          `}
        />
        <Typography.Label
          medium
          size={rpx(11)}
          lineHeight={rpx(15)}
          color={color}
        >
          {subscribed ? '已关注' : '未关注'}
        </Typography.Label>
      </HStack>
    );
  },
);
